export const navLinks = [
  { navLinkId: 'ABOUT', scrollToId: 'aboutContainer' },
  { navLinkId: 'PROGRAM', scrollToId: 'programContainer' },
  { navLinkId: 'SPEAKERS', scrollToId: 'speakersContainer' },
];
